"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgTeddyBear = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M17 8.926c0 2.77-2.239 4.053-5 4.053s-5-1.283-5-4.053c0-.157.007-.31.022-.46 0 0-2.022-1.503-.415-3.554 1.606-2.052 3.835 0 3.835 0A7.193 7.193 0 0112 4.748c.544 0 1.068.055 1.558.164 0 0 2.442-2.052 3.942 0 1.5 2.05-.521 3.554-.521 3.554.014.15.021.303.021.46zm-3.125-.417a.626.626 0 10-.002-1.252.626.626 0 00.002 1.252zm-3.75 0a.626.626 0 10-.002-1.251.626.626 0 00.002 1.252z' }),
    react_1.default.createElement("path", { d: 'M6.765 11.283a4.867 4.867 0 00-.265-.309s-1.5 0-1.5 1.59c0 1.92 1.5 1.92 1.5 1.92H7C5 18.496 7 20 8.5 20s2-1.003 2-1.003h3S14 20 15.5 20c2.5 0 3-2.507 1.5-5.516h.5s1.5 0 1.5-1.92c0-1.59-1.5-1.59-1.5-1.59-.076.07-.174.188-.298.337-.7.838-2.23 2.672-5.202 2.672-3.02 0-4.55-1.866-5.235-2.7z' }))); };
exports.default = SvgTeddyBear;
//# sourceMappingURL=TeddyBear.js.map